import ReactDOM from 'react-dom/client';
import App from './App';
import { Toaster } from '@/components/ui/toaster';
import { ThemeProvider } from '@/components/theme-provider';
import '@/index.css';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from '@/redux/store';

ReactDOM.createRoot(document.getElementById('root')!).render(
  
 
<Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <ThemeProvider defaultTheme='light' storageKey='vite-ui-theme'>
      <App />
      <Toaster />
      
    </ThemeProvider>
     
    </PersistGate>
  </Provider>,
);